import { useNavigate } from 'react-router'
import { FaArrowLeft } from 'react-icons/fa'

const Surprise: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className="border-theme flex h-dvh max-w-[600px] flex-col items-center justify-center border">
      <div className="border-theme sticky top-0 left-0 z-[80] flex h-[60px] w-full items-center border-b bg-inherit pl-[10px] text-xl font-bold">
        <button
          onClick={() => {
            navigate('/home', { replace: true })
          }}
          className="hover-main flex h-[40px] w-[40px] items-center justify-center rounded-full text-sm"
        >
          <FaArrowLeft />
        </button>
        <p className="pl-[20px] tracking-wide">Congratulations!</p>
      </div>
      <video className="h-full w-full" controls={false} autoPlay={true}>
        <source src="https://ia804609.us.archive.org/4/items/rick-roll/Rick%20Roll.mp4" />
      </video>
    </div>
  )
}

export default Surprise
